import React, { useEffect } from 'react';
import { InkyPenNavbar } from '../InkyPenNavbar/InkyPenNavbar';
import { InkyPenFooter } from '../InkyPenFooter/InkyPenFooter';
import HeroImage from '../Assets/inky-arts/404_2024.png';
import './InkyPenNotFound.scss';
import Log from '../Services/Logger';
import apiClient from '../../API/InkyAPI';
import AnalyticsEvent from '../../Models/Analytics/AnalyticsEvent';
import { useAtom } from 'jotai';
import { AnalyticsIdAtom, AnalyticsUserProxyAtom } from '../../store/AnalyticsStore';
import { AccountInfoAtom } from '../../store/AccountStore';
import { Link } from 'react-router-dom';

export function InkyPenNotFound(): JSX.Element {

    const [analyticsId] = useAtom(AnalyticsIdAtom);
    const [accountInfo] = useAtom(AccountInfoAtom);
    const [analyticsUserProxy] = useAtom(AnalyticsUserProxyAtom);

    useEffect(() => {
        Log.debug('Page Not Found.');
        apiClient.sendEvent(accountInfo, new AnalyticsEvent(analyticsId.toString(),
            'NOT_FOUND',
            location.pathname, window.location.href, analyticsUserProxy.toString())).then(res => {
            //console.log(res.data);
        });
    }, []);

    return (
        <div>
            <InkyPenNavbar />
            <div>

                <div className={'inky-not-found-wrapper'}>
                    <img className='hero-image' src={HeroImage} alt={'Inkypen 404 Hero'} />
                    <div className={'inky-not-found-text'}>
                        {`
                            This page might have been removed or is temporarily unavailable.
                            If it\'s supposed to be here we'll try to find it. Why not check out our catalogue while you wait?
                        `}
                    </div>

                    <div className='inky-not-found-redirect-wrapper'>
                        <Link to={''} className='inky-not-found-redirect'>
                            Browse our catalogue
                        </Link>

{/*                        <Link to={'/browse'} className='inky-not-found-redirect'>
                            Browse our catalogue
                        </Link>*/}
                    </div>
                </div>
            </div>
            <InkyPenFooter />
        </div>);
}